import { createStyles, TFMarkdownText } from '@tf/ui';
import type React from 'react';

const useStyles = createStyles({
	root: {
		marginTop: '1rem',

		'& h1, h2, h3, h4, h5': {
			fontWeight: 500,
		},

		'& p, ul, ol': {
			marginTop: '0.5rem',
			marginBottom: '0.5rem',
		},
	},
});

export const MarkdownText: React.FC<{ text: string; className?: string }> = ({ text, className }) => {
	const { classes } = useStyles();

	return <TFMarkdownText className={className ?? classes.root} text={text} />;
};
